import React, { useEffect, useState } from 'react';
import InputText from '../../components/agv-forms-input';
import GenericModal from '../../components/agv-generic-modal';
import TextArea from '../../components/agv-forms-textarea';
import InputCombobox from '../../components/agv-forms-combobox/input-combobox';
import InputRadio from '../../components/agv-forms-radio';
import {
  CRITICALITIES,
  CRITICALITIES_DISPLAY_NAME,
} from '../../enums/criticalities-enum.enum';

export default function ReserveReasonUpdateModal({
  isOpen,
  setIsOpen,
  updateReserveReason,
  archiveReserveReason,
  mainActionIsLoading,
  isLoadingArchiveReserveReason,
  reserveReason,
}) {
  const [reasonMessage, setReasonMessage] = useState(
    reserveReason?.reason_message
  );
  const [description, setDescription] = useState(reserveReason?.description);
  const [criticality, setCriticality] = useState(reserveReason?.criticality);
  const [types, setTypes] = useState(reserveReason?.types);

  const isEmpty =
    !reasonMessage?.length || !criticality?.length || !types?.length;

  const isSameValues =
    reasonMessage === reserveReason?.reason_message &&
    description === reserveReason?.description &&
    criticality === reserveReason?.criticality &&
    JSON.stringify(types) === JSON.stringify(reserveReason?.types);

  const DISABLED = isEmpty || isSameValues;

  useEffect(() => {
    if (isOpen) {
      setReasonMessage(reserveReason?.reason_message);
      setDescription(reserveReason?.description);
      setCriticality(reserveReason?.criticality);
      setTypes(reserveReason?.types);
    }
  }, [isOpen]);

  const handleArchiveReserveReason = () => {
    if (
      window.confirm(
        reserveReason?.is_archived
          ? 'Êtes-vous sûr de vouloir réactiver la catégorie de réserve ?'
          : 'Êtes-vous sûr de vouloir archiver la catégorie de réserve ?'
      )
    ) {
      archiveReserveReason(reserveReason?.id);
    }
  };

  const handleChangeSelectedTypes = (selectedType) => {
    if (selectedType.includes('ALL')) {
      selectedType = [
        'LIVRAISON',
        'REPRISE',
        'TRANSVIDAGE',
        'TRANSFERT-SILO',
      ].map((selectedType) => selectedType);
    }
    setTypes(selectedType);
  };

  return (
    <GenericModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={'Modifier une catégorie de réserve'}
      mainAction={() =>
        updateReserveReason(
          reserveReason?.id,
          reasonMessage,
          description,
          '',
          criticality,
          types
        )
      }
      mainActionText={'Modifier'}
      mainActionIsLoading={mainActionIsLoading}
      mainActionDisabled={DISABLED}
      secondaryAction={handleArchiveReserveReason}
      secondaryActionIsLoading={isLoadingArchiveReserveReason}
      secondaryActionText={
        reserveReason?.is_archived ? 'Réactiver' : 'Archiver'
      }
    >
      <div className="tw-flex tw-flex-col">
        <InputText
          value={reasonMessage}
          setValue={setReasonMessage}
          fieldTitle={'Nom'}
          isRequired
          emptyError={`Le champ "Nom" ne peut être vide.`}
          style={''}
          placeholder={'Leblanc'}
        />
        <TextArea
          value={description}
          setValue={setDescription}
          fieldTitle={'Description'}
          style={'tw-mt-4'}
        />
        {/* <InputCombobox
          value={icon || ''}
          setValue={setIcon}
          fieldTitle={'Icône'}
          items={[
            {
              name: 'Aucune icône',
              icon: '',
              value: '',
            },
            ...RESERVE_REASONS_ICONS_ARRAY.map((element) => ({
              name: RESERVE_REASONS_ICONS_DISPLAY_NAME[element],
              icon: RESERVE_REASONS_ICONS_DISPLAY[element],
              value: element,
            })),
          ]}
          hasIcon
          style={'tw-mt-4'}
        /> */}
        <InputCombobox
          value={types}
          setValue={handleChangeSelectedTypes}
          placeholder={"Sélectionnez parmi les types d'étapes possibles"}
          fieldTitle={"Types d'étapes"}
          items={[
            {
              name: "Tous les types d'étapes",
              value: 'ALL',
            },
            ...['LIVRAISON', 'REPRISE', 'TRANSVIDAGE', 'TRANSFERT-SILO'].map(
              (element) => ({
                name: element,
                value: element,
              })
            ),
          ]}
          isRequired
          emptyError={`Le champ "Types d'étapes" ne peut être vide.`}
          style={'tw-mt-4'}
          isMultiple
          maxValueToDisplay={3}
        />
        <InputRadio
          value={criticality}
          setValue={setCriticality}
          fieldTitle={'Criticité'}
          style={'tw-mt-4'}
          items={Object.keys(CRITICALITIES).map((element) => ({
            name: CRITICALITIES_DISPLAY_NAME[element],
            value: element,
          }))}
        />
      </div>
    </GenericModal>
  );
}
